export default __webpack_public_path__ + "static/media/bonus-received-ico.aee4fc99.svg";